import { createContext, useState } from "react"
import PropTypes from "prop-types"
import { useData } from "~/hooks/useData"
import { useGrid } from "~/hooks/useGrid"
import { useFocus } from "~/hooks/useFocus"

export const MultiContext = createContext()

export function MultiContextProvider({ children }) {
  const {
    gridConfig,
    layout,
    setLayout,
    dimensions,
    breakpoint,
    queryString,
    setQueryString,
    controlsEnabled,
    setControlsEnabled,
  } = useGrid()
  const {
    data,
    positions,
    addVideo,
    updateVideo,
    removeAll,
    removeVideo,
    pauseAll,
    playAll,
    playPause,
    muteAll,
    unMuteAll,
    muteUnMute,
    muteAllBut,
    swapPositions,
    firstAvailablePosition,
  } = useData(queryString, setQueryString)
  const { focus, setFocus, focusRef } = useFocus()
  const [isCommandMenuOpen, setIsCommandMenuOpen] = useState(false)
  const [isCommandMenuFocused, setIsCommandMenuFocused] = useState(false)
  const [selectedCommandMenuOption, setSelectedCommandMenuOption] = useState(null)

  return (
    <MultiContext.Provider
      value={{
        data,
        positions,
        addVideo,
        updateVideo,
        removeAll,
        removeVideo,
        pauseAll,
        playAll,
        playPause,
        muteAll,
        unMuteAll,
        muteUnMute,
        muteAllBut,
        swapPositions,
        firstAvailablePosition,
        gridConfig,
        layout,
        setLayout,
        focus,
        setFocus,
        focusRef,
        dimensions,
        breakpoint,
        queryString,
        setQueryString,
        controlsEnabled,
        setControlsEnabled,
        isCommandMenuOpen,
        setIsCommandMenuOpen,
        isCommandMenuFocused,
        setIsCommandMenuFocused,
        selectedCommandMenuOption,
        setSelectedCommandMenuOption,
      }}
    >
      {children}
    </MultiContext.Provider>
  )
}
MultiContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
